export default __webpack_public_path__ + "static/media/solana.45a90507.png";